import './App.css';
import ReactGA from 'react-ga';
import { initGA, PageView } from './Components/Shared/TrackingId';
import { Route, BrowserRouter, Switch, HashRouter } from 'react-router-dom';
import Home from './Components/Pages/Home/Home';
import createAuthContext from './lib/createAuthContext';
import { ErrorBoundary } from './Rollbar/ErrorBoundary';
import ErrorBoundaryLoggly from './Loggly/ErrorBoundaryLoggly';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import  Layout from './Layout/Layout';
import { fetchTokenPath } from './Services/config/apiGateway';
const cryptoRandomString = require('crypto-random-string');
const e_State = cryptoRandomString({length: 10, type: 'alphanumeric'})
const clientId = process.env.REACT_APP_CLIENT_ID || "f1d4d39a-5888-481c-a562-a49d7748f054"
const provider = process.env.REACT_APP_PROVIDER || `${fetchTokenPath}auth?state=${e_State}&`
const {AuthContext, Authenticated, useToken} = createAuthContext({
  clientId,
  provider,
  scopes:["f1d4d39a-5888-481c-a562-a49d7748f054 offline_access"],
})
// Note : You have to change Redirect_URI in lib/helpers/autorize and /lib/helpers/fetchToken
function App() {
// console.log = () =>{}
  const loaderValueR = useSelector(state => state.loaderReducer.loaderValue);
  initGA('UA-182650766-1');
  PageView();
  return (
    <div id={!loaderValueR ? "disabletrue" : ""}>
 <ErrorBoundary>
        {/* <ErrorBoundaryLoggly> */}
   <AuthContext><Authenticated>
   <HashRouter>
              <Switch>
                <Route exact path="/" component={Home} />
                {/* <Route path='/' render={(props) => <PreLoginLayout {...props} />} /> */}
                <Route path='/' render={(props) => <Layout {...props} />} />
              </Switch>
          </HashRouter>
      </Authenticated></AuthContext>
 {/* </ErrorBoundaryLoggly> */}
      </ErrorBoundary>
    </div>
  );
}
App.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.func.isRequired
}
export default App;
